import { Link } from 'react-router-dom';

const articles = [
  {
    slug: '/sugargoo-spreadsheet-guide',
    title: 'Complete Sugargoo Spreadsheet Guide 2026',
    description: 'Everything you need to know about finding, using, and mastering Sugargoo spreadsheets for smarter international shopping.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20minimalist%20desk%20workspace%20featuring%20an%20open%20laptop%20with%20spreadsheet%20interface%20alongside%20neatly%20arranged%20fashion%20product%20photos%20and%20fabric%20swatches%2C%20warm%20cream%20and%20beige%20tones%2C%20soft%20natural%20daylight%20from%20a%20large%20window%2C%20editorial%20photography%20with%20clean%20composition%20and%20gentle%20shadows&width=800&height=500&seq=article-card-1&orientation=landscape',
    imageAlt: 'Complete Sugargoo spreadsheet guide with organized product discovery workspace',
    readTime: '12',
    tag: 'Ultimate Guide',
  },
  {
    slug: '/sugargoo-review',
    title: 'Sugargoo Review 2026: Is It Legit?',
    description: 'An honest and detailed review of the Sugargoo shopping platform covering safety, reliability, pros and cons, and real user experiences.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20review%20scene%20with%20a%20tablet%20displaying%20a%20shopping%20platform%20interface%20next%20to%20product%20samples%20on%20a%20warm%20oak%20desk%2C%20cream%20and%20sand%20color%20palette%2C%20soft%20diffused%20lighting%2C%20editorial%20business%20photography%2C%20clean%20modern%20workspace%20with%20handwritten%20notes%20and%20a%20coffee%20cup&width=800&height=500&seq=article-card-2&orientation=landscape',
    imageAlt: 'Sugargoo review and legitimacy analysis with shopping platform interface',
    readTime: '10',
    tag: 'Review',
  },
  {
    slug: '/sugargoo-shipping-guide',
    title: 'Sugargoo Shipping Cost & Time Guide',
    description: 'A complete breakdown of Sugargoo shipping methods, costs, delivery times, and how to choose the best option for your orders.',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20logistics%20and%20shipping%20concept%20with%20neatly%20arranged%20cardboard%20boxes%20and%20shipping%20labels%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20product%20photography%2C%20beige%20and%20sand%20tones%2C%20organized%20composition%20with%20measuring%20tape%20and%20packing%20materials&width=800&height=500&seq=article-card-3&orientation=landscape',
    imageAlt: 'Sugargoo shipping cost and delivery time guide with shipping concept',
    readTime: '9',
    tag: 'Shipping',
  },
  {
    slug: '/sugargoo-coupon-guide',
    title: 'Sugargoo Coupons & Discount Codes 2026',
    description: 'Find the latest Sugargoo coupon codes, discount strategies, and insider tips to save money on every international order.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20shopping%20savings%20concept%20with%20gift%20cards%20and%20discount%20tags%20arranged%20on%20a%20warm%20cream%20marble%20surface%2C%20soft%20golden%20ambient%20light%2C%20editorial%20lifestyle%20photography%2C%20beige%20and%20warm%20sand%20tones%2C%20clean%20sophisticated%20composition%20with%20a%20laptop%20showing%20a%20checkout%20page&width=800&height=500&seq=article-card-4&orientation=landscape',
    imageAlt: 'Sugargoo coupons and discount codes savings guide',
    readTime: '7',
    tag: 'Savings',
  },
  {
    slug: '/sugargoo-warehouse-guide',
    title: 'Sugargoo Warehouse Complete Guide',
    description: 'Understand how the Sugargoo warehouse works, storage policies, inspection services, and how to manage your stored items efficiently.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20warehouse%20interior%20with%20neatly%20stacked%20boxes%20on%20shelving%20units%20bathed%20in%20warm%20natural%20light%2C%20cream%20and%20beige%20industrial%20aesthetic%2C%20soft%20focus%20background%2C%20editorial%20commercial%20photography%2C%20orderly%20composition%20with%20inventory%20labels%20and%20packing%20stations&width=800&height=500&seq=article-card-5&orientation=landscape',
    imageAlt: 'Sugargoo warehouse guide with organized storage and inventory management',
    readTime: '8',
    tag: 'Warehouse',
  },
  {
    slug: '/best-sugargoo-spreadsheet',
    title: 'Best Sugargoo Spreadsheets 2026',
    description: 'Discover the most popular and highest-rated Sugargoo spreadsheets across all categories, hand-picked by the community.',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20product%20images%20arranged%20in%20a%20grid%20pattern%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20flatlay%20photography%2C%20neutral%20beige%20and%20sand%20tones%2C%20organized%20and%20clean%20composition%20with%20handwritten%20labels%20and%20star%20ratings&width=800&height=500&seq=article-card-6&orientation=landscape',
    imageAlt: 'Best Sugargoo spreadsheets curated collection of top-rated product lists',
    readTime: '10',
    tag: 'Top Picks',
  },
  {
    slug: '/sugargoo-spreadsheet-tips',
    title: 'Expert Sugargoo Spreadsheet Tips & Tricks',
    description: 'Advanced strategies and expert tips from experienced shoppers to maximize your Sugargoo spreadsheet experience.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20organized%20notebooks%20and%20sticky%20notes%20containing%20shopping%20strategies%20on%20a%20warm%20oak%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20productivity%20photography%2C%20cream%20and%20beige%20palette%2C%20clean%20composition%20with%20a%20laptop%20showing%20data%20and%20analytics&width=800&height=500&seq=article-card-7&orientation=landscape',
    imageAlt: 'Expert Sugargoo spreadsheet tips and tricks for advanced shopping',
    readTime: '8',
    tag: 'Tips',
  },
  {
    slug: '/sugargoo-spreadsheet-beginners',
    title: "Beginner's Guide to Sugargoo Spreadsheets",
    description: 'New to Sugargoo spreadsheets? This step-by-step guide walks you through everything from setup to your first successful purchase.',
    image: 'https://readdy.ai/api/search-image?query=Welcoming%20beginner-friendly%20workspace%20with%20a%20simple%20laptop%20showing%20an%20onboarding%20screen%20next%20to%20a%20warm%20cup%20of%20tea%20on%20a%20cream%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20editorial%20lifestyle%20photography%2C%20warm%20beige%20and%20sand%20tones%2C%20inviting%20clean%20composition%20with%20a%20notebook%20and%20pen&width=800&height=500&seq=article-card-8&orientation=landscape',
    imageAlt: "Beginner's guide to Sugargoo spreadsheets with step-by-step tutorial",
    readTime: '11',
    tag: 'Beginners',
  },
  {
    slug: '/sugargoo-product-finds',
    title: 'Top Sugargoo Product Finds This Month',
    description: 'Check out the hottest product discoveries from Sugargoo spreadsheets, featuring trending fashion, accessories, and must-have items.',
    image: 'https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20including%20sneakers%20bag%20and%20accessories%20beautifully%20arranged%20on%20a%20warm%20cream%20backdrop%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20neutral%20beige%20and%20sand%20tones%2C%20clean%20aspirational%20composition%20with%20lifestyle%20elements%20and%20natural%20textures&width=800&height=500&seq=article-card-9&orientation=landscape',
    imageAlt: 'Top Sugargoo product finds featuring trending fashion and accessories',
    readTime: '9',
    tag: 'Trending',
  },
];

export default function ArticleCardsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            SEO Articles & Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Sugargoo Spreadsheet Articles &amp; Resources
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Dive deep into our comprehensive collection of guides, reviews, and expert insights to master your international shopping journey
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group flex flex-col rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-all duration-200 overflow-hidden"
            >
              <div className="w-full aspect-[16/10] overflow-hidden bg-background-200/50">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-medium whitespace-nowrap">
                    {article.tag}
                  </span>
                  <span className="text-[10px] text-foreground-400 flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-time-line text-[10px]"></i>
                    </span>
                    {article.readTime} min read
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {article.description}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                  Read Article
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}